import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { createRoot } from 'react-dom/client'
import 'slick-carousel/slick/slick.css'
import moment from 'moment'
import React from 'react'
import 'locales/i18n'

import { LastVisitedPageProvider } from 'shared/hooks/LastPageHook'
import PrivateRoute from 'shared/components/PrivateRoute'
import Unauthorized from 'views/Unauthorized'
import { ThemeConfig } from 'config/theme'
import Authorized from 'views/Authorized'
import { UserRoles } from 'shared/consts'

moment.updateLocale('en-EN', {
   months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
   ],
   monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
   weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
   weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],

   relativeTime: {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      w: 'a week',
      ww: '%d weeks',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years',
   },
   week: {
      dow: 1,
   },
})

moment.defineLocale('pl-PL', {
   months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
   ],
   monthsShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'ip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
   weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
   weekdaysShort: ['Nd', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
   relativeTime: {
      future: 'w %s',
      past: '% temu',
      s: 'kilka sekund',
      ss: '%d sekund',
      m: 'minuta',
      mm: '%d minut',
      h: 'godzina',
      hh: '%d godzin',
      d: 'dzień',
      dd: '%d dni',
      w: 'tydzień',
      ww: '%d tygodni',
      M: 'miesiąc',
      MM: '%d miesięcy',
      y: 'rok',
      yy: '%d lata',
   },
   week: {
      dow: 1,
   },
})

const queryClient = new QueryClient({
   defaultOptions: {
      queries: {
         retryDelay: 20000,
         retry: 2,
         refetchOnWindowFocus: false,
      },
   },
})

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
   <React.StrictMode>
      <ThemeConfig>
         <QueryClientProvider client={queryClient}>
            <BrowserRouter>
               <LastVisitedPageProvider>
                  <Routes>
                     <Route path="*" element={<Unauthorized />} />
                     <Route
                        path="dashboard/*"
                        element={
                           <PrivateRoute
                              component={Authorized}
                              roles={[
                                 UserRoles.MAIN_LOCALIZATION_ADMIN,
                                 UserRoles.REGISTERED_USER,
                                 UserRoles.SUBSCRIPTION,
                              ]}
                           />
                        }
                     />
                  </Routes>
               </LastVisitedPageProvider>
            </BrowserRouter>
            <ReactQueryDevtools initialIsOpen />
         </QueryClientProvider>
      </ThemeConfig>
   </React.StrictMode>
)
